import { render, staticRenderFns } from "./AdvancedUsage.vue?vue&type=template&id=132e08da&"
import script from "./AdvancedUsage.vue?vue&type=script&lang=js&"
export * from "./AdvancedUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports